module.exports = __webpack_public_path__ + "img/monthly-logo-icon.ecff5c8d.png";